export default {

  data() {
    return {
      tc: false,

    }
  },
  props: ['value'],
  mounted() {
    let context = this

    $('.pa').focus(function () {


      let ps = `<ul class="password-validator" id="vs" >
 
                <li id="capital" class="invalid"><i class="symb"></i> At least<strong> one Upper Case</strong></li>
                <li id="number" class="invalid"><i class="symb"></i> At Least<strong> one Special Character</strong></li>
                <li id="length" ><i class="symb"></i> At  least<strong> 8 characters</strong></li>
            
               </ul>`
      $(this).parent().last().append(ps)

      let sent = $(this).val();

      context.initializevalidator(sent);


      $(this).bind('input', function () {

        let sent = $(this).val()
        
        
        context.initializevalidator(sent);



      })


    })

    $('.pa').focusout(function () {

      $('#vs').remove();


    });


  },

  methods: {

    initializevalidator(sent) {

      if (sent.length >= 8) {
        $('.password-validator').find('li:nth-child(3) .symb').html('<i class="fa fa-check" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(3)').css('color', 'rgb(18, 255, 233)')
      }
      else {
        $('.password-validator').find('li:nth-child(3) .symb').html('<i class="fa fa-close" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(3)').css('color', 'white')
      }

      // Special character check

      if (sent.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/)) {

        $('.password-validator').find('li:nth-child(2) .symb').html('<i class="fa fa-check" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(2)').css('color', 'rgb(18, 255, 233)')
      }
      else {
        $('.password-validator').find('li:nth-child(2) .symb').html('<i class="fa fa-close" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(2)').css('color', 'white')

      }

      if (sent.match(/^(?=.*[A-Z])/)) {

        $('.password-validator').find('li:nth-child(1) .symb').html('<i class="fa fa-check" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(1)').css('color', 'rgb(18, 255, 233)')
      }
      else {
        $('.password-validator').find('li:nth-child(1) .symb').html('<i class="fa fa-close" aria-hidden="true"></i>')
        $('.password-validator').find('li:nth-child(1)').css('color', 'white')

      }

      

    }


  }

}



// WEBPACK FOOTER //
// ./src/components/password-validator/PasswordValidator.js